import type { PaletteMode } from '@mui/material';

export interface ActionReviewPalette {
  pageBackground: string;
  title: string;
  subtleBorder: string;
  navigationBackground: string;
  selectedBackground: string;
  mutedText: string;
  bannerBackground: string;
  bannerBorder: string;
  tableHeaderBackground: string;
  cardBackground: string;
  suggestionStatusBackground: string;
  actionStatusBackground: string;
  evidenceSource: string;
  timelineBorder: string;
}

declare module '@mui/material/styles' {
  interface Palette {
    actionReview: ActionReviewPalette;
  }

  interface PaletteOptions {
    actionReview?: ActionReviewPalette;
  }
}

/**
 * The reviewed-Actions palette belongs to the shared theme so contrast and
 * future brand changes propagate without another page-local color system.
 */
export const getActionReviewPalette = (
  mode: PaletteMode,
): ActionReviewPalette =>
  mode === 'light'
    ? {
        pageBackground: '#ffffff',
        title: '#211f26',
        subtleBorder: '#ddd6d0',
        navigationBackground: '#fbfaf9',
        selectedBackground: '#f4ead1',
        mutedText: '#6b7280',
        bannerBackground: '#fcf8ef',
        bannerBorder: '#d7c7ba',
        tableHeaderBackground: '#faf9f8',
        cardBackground: '#fafafa',
        suggestionStatusBackground: '#fff4d6',
        actionStatusBackground: '#edf7f4',
        evidenceSource: '#0f766e',
        timelineBorder: '#d7c7ba',
      }
    : {
        pageBackground: '#17181c',
        title: '#f4f4f5',
        subtleBorder: '#34363e',
        navigationBackground: '#17181c',
        selectedBackground: '#2a2638',
        mutedText: '#a8abb3',
        bannerBackground: '#221f34',
        bannerBorder: '#4b416f',
        tableHeaderBackground: '#1e1f23',
        cardBackground: '#1e1f23',
        suggestionStatusBackground: '#4d3d20',
        actionStatusBackground: '#173c36',
        evidenceSource: '#64d8cb',
        timelineBorder: '#4b416f',
      };
